export default class TrailCollection {
  constructor() {
    this.trails = {};
    this.debug = {
      vertexCount: 0,
      drawVertexCount: 0,
      bufferSize: 0,
    };
  }

  onSceneLoad(globes) {
    this.globes = globes;
  }

  create(id, options) {
    console.assert(!this.trails[id], 'Trail id must be unique');
    this.trails[id] = id;
    this.globes.forEach(g => g.createTrail(id, options));
  }

  destroy(id) {
    console.assert(this.trails[id], 'Invalid Trail ID');
    this.globes.forEach(g => g.removeTrail(id));
    delete this.trails[id];
  }

  onPointsAdded(id, newVertices) {
    if (this.trails[id]) {
      this.globes.forEach(g => g.onPointsAdded(id, newVertices));
    }
  }

  update(store) {
    const state = store.getState();

    const length = state.scene.sceneSettings.trailLength;
    const activeId = state.tracks.activeTrack;
    const trailIds = Object.keys(this.trails);

    trailIds.forEach(id => {
      const def = state.activities[id];
      const head = state.playheads[id];

      const distance = head && head.ready ? head.cumulative : 0.0;
      const visible = def ? def.show : true;
      const active = id === activeId;

      this.globes.forEach(g => g.updateTrail(id, distance, length, visible, active));
    });
  }
}
